// src/config.js
const BASE_URL = 'https://in-engr-nova.it.purdue.edu/api';
export default BASE_URL; 

// src/config.js/localhost 
/*const BASE_URL = 'http://localhost:8001/api'; // Port 8001 
export default BASE_URL;*/
